import { Routes, Route } from "react-router-dom";
import PageLayout from "../../Pages/PageLayout";
import { Toiture } from "../../Pages/Toiture/Toiture";
import MurUsage from "../../Pages/Mur-usage/MurUsage";
import Charpente from "../../Pages/Charpente/Charpente";
import Cadrage from "../../Pages/Cadrage-projet/Cadrage";
import DimensionsPlans from "../../Pages/DimensionsPlans";
import Home from "../../Pages/Home/Component/Home";
// import Login from "../../Pages/Login/Login"; // Désactivé pour permettre l'accès sans authentification
import ProjectStep from "../../Pages/ProjectStep";
import ProjectStepTest from "../../Pages/ProjectStep/ProjectStepTest";
import DemandesList from "../../Pages/DemandesList/DemandesList";
import DemandeDetailsPage from "../../Pages/DemandesList/DemandeDetailsPage";
// import ProtectedRoute from "../../components/ProtectedRoute";
// import ProtectedRoute from "../ProtectedRoute" // Désactivé pour permettre l'accès sans authentification

const Routers = () => {

    return(
        <>
            
                <Routes>
                    {/* <Route path="/login" element={<Login />} /> */} {/* Désactivé pour permettre l'accès sans authentification */}
                    {/* <Route element={<ProtectedRoute><PageLayout /></ProtectedRoute>}> */} {/* Désactivé pour permettre l'accès sans authentification */}
                    <Route element={<PageLayout />}>
                        <Route path="/" element={<Home />} />
                        <Route path="/cadrage" element={<Cadrage />} />
                        <Route path="/toiture" element={<Toiture />} />
                        <Route path="/mur-usage" element={<MurUsage />} />
                        <Route path="/charpente" element={<Charpente />} />
                        <Route path="/dimensions" element={<DimensionsPlans />} />
                        <Route path="/projet/:projectId/etape/:stepSlug" element={<ProjectStep />} />
                        <Route path="/test-navigation/:projectId/etape/:stepSlug" element={<ProjectStepTest />} />
                        <Route path="/demandes" element={<DemandesList />} />
                        <Route path="/demande/:id" element={<DemandeDetailsPage />} />
                    </Route>
                    {/* </Route> */} {/* Désactivé pour permettre l'accès sans authentification */}
                </Routes>
            
        </>
    )
}

export default Routers;